import { Project } from '@tmh-website/shared/const';

import type { LogoWrapperProps } from './Header.styles';

/**
 * Resolves the applicable height of the logo wrapper based on the project type and custom logo presence.
 *
 * @param project - The current project.
 * @param hasCustomLogo - Indicates whether a custom logo is present.
 *
 * @returns - The height of the logo wrapper in pixels.
 */
export const getLogoWrapperHeight = (project: Project, hasCustomLogo: boolean): LogoWrapperProps['$height'] => {
  if (hasCustomLogo) {
    return 60;
  }

  return project === Project.Energy ? 60 : 40;
};
